import { BoobleModalService } from 'booble-modal';
import { Component } from "@angular/core";

@Component({
    templateUrl: './privacy-policy-modal.component.html',
    styleUrls: ['./privacy-policy-modal.component.scss']
})
export class PrivacyPolicyModal {

    constructor(private modalService: BoobleModalService) { }

    close() {
        this.modalService.dismiss(null);
    }

}